<script setup>
import VDevider from "@/Shared/VDevider.vue";

import { DEPARTING_ENUM } from "../tabs.config";
import VFormDemographic from "../../../../Shared/Survey/Departing/VFormDemographic.vue";
import VFormTravel from "../../../../Shared/Survey/Departing/VFormTravel.vue";
import VFormEntryPoint from "../../../../Shared/Survey/Departing/VFormEntryPoint.vue";
import VFormTravelArrangement from "../../../../Shared/Survey/Departing/VFormTravelArrangement.vue";
import VFormExpense from "../../../../Shared/Survey/Departing/VFormExpense.vue";
import VFormAirEntryPoint from "../../../../Shared/Survey/Departing/VFormAirEntryPoint.vue";
import VFormVacation from "../../../../Shared/Survey/Departing/VFormVacation.vue";
import VFormFeedbacks from "../../../../Shared/Survey/Departing/VFormFeedbacks.vue";
import { computed, ref, watch } from "vue";

const props = defineProps({
    tab: Object,
    surveyFields: Object,
    answers: Object,
    errors: Object,
});

const emits = defineEmits(["onNext", "onPrev"]);
const form = ref(props.answers);

const byAirOption =
    props.surveyFields
        .which_of_the_following_entry_point_did_you_go_through_to_enter_sabah
        .options[0];

watch(
    () => props.tab?.key,
    (value) => {
        if (
            value == DEPARTING_ENUM.FORM_4 &&
            byAirOption !=
                form.value
                    ?.which_of_the_following_entry_point_did_you_go_through_to_enter_sabah
        ) {
            emits("onNext", { ...form.value });
        }
    }
);

const activeComponent = computed({
    get() {
        const additional = {
            surveyFields: props.surveyFields,
            answers: form.value,
            errors: props.errors,
        };

        switch (props.tab.key) {
            case DEPARTING_ENUM.FORM_1:
                return {
                    component: VFormDemographic,
                    additional: additional,
                };
            case DEPARTING_ENUM.FORM_2:
                return {
                    component: VFormTravel,
                    additional: additional,
                };
            case DEPARTING_ENUM.FORM_3:
                return {
                    component: VFormEntryPoint,
                    additional: additional,
                };
            case DEPARTING_ENUM.FORM_4:
                return {
                    component: VFormAirEntryPoint,
                    additional: additional,
                };
            case DEPARTING_ENUM.FORM_5:
                return {
                    component: VFormTravelArrangement,
                    additional: additional,
                };
            case DEPARTING_ENUM.FORM_6:
                return {
                    component: VFormExpense,
                    additional: additional,
                };
            case DEPARTING_ENUM.FORM_7:
                return {
                    component: VFormVacation,
                    additional: additional,
                };
            case DEPARTING_ENUM.FORM_8:
                return {
                    component: VFormFeedbacks,
                    additional: additional,
                };
        }
    },
});

const handelOnNext = (data) => {
    for (let props in data) {
        form.value[props] = data[props];
    }

    emits("onNext", { ...form.value });
};
</script>

<template>
    <div class="row">
        <div class="col-12">
            <h5>
                {{ $t("public.page.survey.tab_dvs." + tab.key) ?? tab.title }}
            </h5>
            <VDevider class="mb-4" />
            <KeepAlive>
                <component
                    :is="activeComponent.component"
                    :additional="activeComponent.additional"
                    @onNext="handelOnNext"
                    @onPrev="emits('onPrev')"
                />
            </KeepAlive>
        </div>
    </div>
</template>
